import { isCaption } from './optionsCreationUtils';
import {
  DETAILS_MAP_ENABLED,
  DETAILS_MAP_RESTRICTED,
  LABELS_MAP } from
'../constants';

const LANGUAGES = {
  EN: 'English (US)',
  ZH: 'Chinese',
  FR: 'French',
  JA: 'Japanese',
  KO: 'Korean',
  AR: 'Arabic',
  CS: 'Czech',
  NL: 'Dutch',
  DE: 'German',
  IT: 'Italian',
  PL: 'Polish',
  PT: 'Portuguese',
  RU: 'Russian',
  ES: 'Spanish',
  TR: 'Turkish'
};

const getLangLabel = (lang) => {
  if (lang in LANGUAGES) {
    return LANGUAGES[lang];
  }
  return lang;
};

export const getOptionValues = ({ type, metaData, sourceUrl }) => {
  if (isCaption(type)) {
    return {
      type,
      sourceUrl,
      detailsRestricted: DETAILS_MAP_RESTRICTED[type],
      detailsEnabled: DETAILS_MAP_ENABLED[type],
      label: `${LABELS_MAP[type]} - ${metaData.lang && getLangLabel(metaData.lang.toUpperCase())}`
    };
  }

  return {
    type,
    sourceUrl,
    detailsRestricted: DETAILS_MAP_RESTRICTED[type],
    detailsEnabled: DETAILS_MAP_ENABLED[type],
    label: LABELS_MAP[type]
  };
};